const initState = {
	data: {
		games: {},
		deck: {},
	},
	status: {
		requested: {},
	},
}

export const localFirestoreReducer = (state = initState, action) => {
	switch (action.type) {
		case 'LOCAL_GAME_REQUESTED':
			return {
				...state,
				status: {
					...state.status,
					requested: {
						...state.status.requested,
						[`games/${action.payload.gamecode}`]: false,
						...(action.payload.includeDeck ? { deck: false } : {}),
					},
				},
			}
		case 'LOCAL_GAME_RECEIVED':
			return {
				...state,
				data: {
					...state.data,
					games: {
						...state.data.games,
						[action.payload.gamecode]: action.payload.game || undefined,
					},
					...(action.payload.includeDeck ? { deck: action.payload.deck || {} } : {}),
				},
				status: {
					...state.status,
					requested: {
						...state.status.requested,
						[`games/${action.payload.gamecode}`]: true,
						...(action.payload.includeDeck ? { deck: true } : {}),
					},
				},
			}
		default:
			return state
	}
}
